module.exports = __webpack_public_path__ + "static/media/sppu.e609415d.jpg";